import React from 'react';
import { Heading, Box, AspectRatio } from '@chakra-ui/react';
import Media from '@components/atoms/Media';
import Link from '@components/atoms/Link';

const RelatedBlogCard = ({ slug, title, image }) => {
  return (
    <Box boxShadow="md" rounded="md" bg="white" overflow="hidden" height="100%">
      <Link
        href={`/blog/${slug}`}
        _hover={{
          textDecoration: `none`
        }}>
        <AspectRatio ratio={4 / 3}>
          <Media
            width="auto"
            objectFit="cover"
            display="inline-flex"
            media={image}
          />
        </AspectRatio>
        <Heading
          p="1rem"
          as="h4"
          fontSize="xl"
          color="purple.600"
          fontWeight="900"
          lineHeight="120%">
          {title}
        </Heading>
      </Link>
    </Box>
  );
};

export default RelatedBlogCard;
